import * as v from "valibot";
import { adminLogEventDto } from "./generator.dto";

const runStatus = v.picklist(["running", "completed", "failed", "paused", "cancelled"]);
const runStage = v.picklist(["articles", "narration", "done"]);
const taskStatus = v.picklist(["pending", "running", "succeeded", "failed", "cancelled"]);
const narrationStatus = v.picklist(["creating", "uploading", "submitted", "processing", "paused", "done", "failed", "canceled"]);

export const adminRunDto = v.object({
  id: v.string(),
  status: runStatus,
  stage: runStage,
  trigger: v.picklist(["schedule", "admin"]),
  startedBy: v.nullable(v.string()),
  pendingTasks: v.number(),
  runningTasks: v.number(),
  succeededTasks: v.number(),
  failedTasks: v.number(),
  cancelledTasks: v.number(),
  costMicros: v.number(),
  durationMs: v.number(),
  inputTokens: v.number(),
  outputTokens: v.number(),
  createdAt: v.number(),
  updatedAt: v.number(),
  settledAt: v.nullable(v.number()),
});
export type AdminRun = v.InferOutput<typeof adminRunDto>;

export const adminRunTaskDto = v.object({
  id: v.string(),
  type: v.picklist(["article"]),
  lane: v.picklist(["articles"]),
  authorAlias: v.string(),
  status: taskStatus,
  attempts: v.number(),
  error: v.nullable(v.object({ code: v.string(), message: v.string() })),
  costMicros: v.nullable(v.number()),
  durationMs: v.nullable(v.number()),
  updatedAt: v.number(),
});
export type AdminRunTask = v.InferOutput<typeof adminRunTaskDto>;

export const adminRunNarrationDto = v.object({
  status: narrationStatus,
  batchId: v.nullable(v.string()),
  pauseReason: v.nullable(v.picklist(["insufficient_credits", "spending_cap"])),
  lastError: v.nullable(v.string()),
  attempts: v.number(),
  articles: v.number(),
  outputs: v.number(),
  failed: v.number(),
  updatedAt: v.number(),
});
export type AdminRunNarration = v.InferOutput<typeof adminRunNarrationDto>;

export const getAdminRunsRequest = { limit: v.optional(v.string()) };

export const getAdminRunsResponse = { runs: v.array(adminRunDto) };
export type GetAdminRunsResponse = v.InferOutput<v.ObjectSchema<typeof getAdminRunsResponse, undefined>>;

export const postAdminRunRequest = { maxAuthors: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(1000))) };

export const postAdminRunResponse = { run: adminRunDto, created: v.boolean() };

export const adminRunIdRequest = { id: v.pipe(v.string(), v.minLength(1), v.maxLength(64)) };

export const getAdminRunResponse = {
  run: adminRunDto,
  tasks: v.array(adminRunTaskDto),
  narration: v.nullable(adminRunNarrationDto),
  /** Where Spoola's dashboard lives, for the batch link. */
  spoolaBaseUrl: v.string(),
};
export type GetAdminRunResponse = v.InferOutput<v.ObjectSchema<typeof getAdminRunResponse, undefined>>;

export const getAdminRunEventsRequest = { ...adminRunIdRequest, since: v.optional(v.string()) };

export const adminRunEventDto = v.object({ ...adminLogEventDto.entries, type: v.string(), authorAlias: v.nullable(v.string()) });
export type AdminRunEvent = v.InferOutput<typeof adminRunEventDto>;

export const getAdminRunEventsResponse = { events: v.array(adminRunEventDto) };
export type GetAdminRunEventsResponse = v.InferOutput<v.ObjectSchema<typeof getAdminRunEventsResponse, undefined>>;

export type PostAdminRunResponse = v.InferOutput<v.ObjectSchema<typeof postAdminRunResponse, undefined>>;
